module.exports = {"632858100":"冷湖镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/632858.json
// module id = 2810
// module chunks = 0